export default "__VITE_ASSET__BJqQ4NWd__"